/**
 * 5度电 APP Tab切换
 */
export function fiveKwhAppList(){
    (function(){
        $(function (){
            const fiveKwhApp = $('.five-kwh-app-list')
            if (fiveKwhApp.length === 0) {
                return;
            }
            const isMobile = window.innerWidth <= 1024;
            fiveKwhApp.each(function(){
                const index = $(this).data('index');
                const currentComponent = `.five-kwh-app-list-${index}`;

                const itemSelector = isMobile ? '.show-mb .app-list-item' : '.show-pc .app-list-item';

                const firstValidItem = $(`${currentComponent}`).find(itemSelector).filter(function() {
                    const appVideo = isMobile ? $(this).data('appmbvideo') : $(this).data('apppcvideo');
                    const appTitle = $(this).data('apptitle');
                    return appVideo && appTitle;
                }).first();

                if (firstValidItem.length > 0) {
                    const toggleCheckbox = firstValidItem.find('.toggle-checkbox');
                    toggleCheckbox.prop('checked', true);
                    const appVideo = isMobile ? firstValidItem.data('appmbvideo') : firstValidItem.data('apppcvideo');
                    const appImage = isMobile ? firstValidItem.data('appmbimage') : firstValidItem.data('apppcimage');
                    const videoLoop = firstValidItem.data('loop') === 'true' ? true : false;
                    let videoDom = renderMediaDom(appVideo, false, videoLoop,appImage);
                    $(`${currentComponent}`).find('.app-list-box').html(videoDom);
                }

                $(`${currentComponent}`).find(itemSelector).on('click', function(e) {
                    const appVideo = isMobile ? $(this).data('appmbvideo') : $(this).data('apppcvideo');
                    const appTitle = $(this).data('apptitle');
                    const appImage = isMobile ? $(this).data('appmbimage') : $(this).data('apppcimage');
                    const videoLoop = $(this).data('loop') === 'true' ? true : false;
                    const toggleCheckbox = $(this).find('.toggle-checkbox');
                    if (appVideo && appTitle && !toggleCheckbox.is(':checked')) {
                        e.stopPropagation();
                        $(`${currentComponent}`).find('.toggle-checkbox').prop('checked', false);
                        toggleCheckbox.prop('checked', true);

                        let videoDom = renderMediaDom(appVideo, false, videoLoop,appImage);
                        $(`${currentComponent}`).find('.app-list-box').html(videoDom);
                    }
                });

                $(`${currentComponent}`).find('.toggle-checkbox').on('click', function(e) {
                    const parentItem = $(this).closest('.app-list-item');
                    const appVideo = isMobile ? parentItem.data('appmbvideo') : parentItem.data('apppcvideo');
                    const appTitle = parentItem.data('apptitle');

                    if (!appVideo || !appTitle) {
                        e.preventDefault();
                        e.stopPropagation();
                        return;
                    }

                    if ($(this).is(':checked')) {
                        e.stopPropagation();
                        return;
                    }

                    $(`${currentComponent}`).find('.toggle-checkbox').not(this).prop('checked', false);
                    $(this).prop('checked', true);
                });

                function videoControl() {
                    document.querySelectorAll(`${currentComponent} video`).forEach((item) => {
                        const isPlaying = item.getAttribute('data-play') === 'true'; // 确定是否在播放

                        if (!isPlaying && window.Jackery.Utils.isElementInViewport(item)) {
                            item.play();
                            item.setAttribute('data-play', 'true');
                        } else if (isPlaying && window.Jackery.Utils.isElementOutOfViewport(item)) {
                            item.pause();
                            item.setAttribute('data-play', 'false');
                        }
                    });
                }

                videoControl();

                // 监听是否在视窗内，处理视频播放与暂停事件
                window.addEventListener('scroll', () => {
                    videoControl();
                })
            })

            function renderMediaDom(videoSrc, controls, loop, src) {
                const type= videoSrc.includes('youtube.com') ? 'youtube' : 'mp4'

                let youtube_id = ''
                let youtube_embed = ''

                if (type === "youtube") {
                    if(videoSrc.indexOf("/embed/") !== -1) {
                        youtube_id = videoSrc.replace("https://www.youtube.com/embed/", "");
                    } else {
                        youtube_id = videoSrc.replace("https://www.youtube.com/watch?v=", "");
                    }
                    youtube_embed = `https://www.youtube.com/embed/${youtube_id}`;
                }

                let media_dom = ''
                switch (type) {
                    case 'mp4':
                        media_dom = `
                    ${src !== undefined ? `<img class="app-list-image" src="${src}" alt="app list image"/>` : ''}
                    <video
                        class="jky-video_media"
                        x5-video-player-type="h5-page"
                        webkit-playsinline="playsinline"
                        playsinline="playsinline"
                        autoplay="autoplay"
                        muted="muted"
                        ${controls ? 'controls="controls"' : ''}
                        preload="metadata"
                        ${loop ? 'loop' : ''} "&width=1500"
                    >
                        <source src="${videoSrc}" type="video/mp4">
                    </video>
                `
                        break;
                    case 'youtube':
                        media_dom = `
                    ${src !== undefined ? `<img class="app-list-image" src="${src}" alt="app list image"/>` : ''}
                    <iframe
                        class="jky-video_media jky-media_youtube rounded-24"
                        src="${youtube_embed}?enablejsapi=1&autoplay=1&${loop ? 'loop=1':''}&playlist=${youtube_id}&mute=1"
                        class="js-youtube global-settings-popup"
                        allow="''; encrypted-media"
                        allowfullscreen=""
                    ></iframe>
                `
                    default:
                        break;
                }
                return media_dom
            }
        })
    })()
}
